module.exports = __webpack_public_path__ + "img/sticker04.ce3cf844.png";